import { DomSanitizer, SafeUrl } from '@angular/platform-browser';
import { Observable, catchError } from 'rxjs';

import { Atividade } from './../../core/models/perfil-profissiografico/atividade';
import { CandidatoLaudo } from '@app/core/models/perfil-profissiografico/candidato-laudo';
import { DetalhePontuacaoCandidato } from '@app/core/models/perfil-profissiografico/detalhar-pontuacao';
import { Injectable } from '@angular/core';
import { MessageService } from 'primeng/api';
import { PerfilProfissiograficoApiService } from '@app/core/services/perfil-profissiografico-api.service';
import { QuestionarioCargo } from '@app/core/models/perfil-profissiografico/questionario-cargo';
import { RespostaCandidato } from '@app/core/models/perfil-profissiografico/resposta-candidato';

@Injectable({
	providedIn: 'any'
})
export class DetalharLaudoService {
	detalharRespostaCandidato$?: Observable<RespostaCandidato>;
	detalharCargo$?: Observable<QuestionarioCargo>;
	detalharLaudo$?: Observable<CandidatoLaudo>;
	detalharPontuacaoCandidato$?: Observable<DetalhePontuacaoCandidato[]>;
	atividades$?: Observable<Atividade[]>;
	radar?: SafeUrl;
	graficoBarras?: SafeUrl;
	graficoLinhas?: SafeUrl;
	idCandidato?: number;

	constructor(
		private perfilProfissiograficoApi: PerfilProfissiograficoApiService,
		private messageService: MessageService,
		private sanitizer: DomSanitizer
	) { }

	detalharLaudo(idCandidato: number) {
		this.detalharLaudo$ = this.perfilProfissiograficoApi.detalharLaudo(idCandidato).pipe(
			catchError(error => {
				this.handleError(error.error.message, '');
				throw error;
			})
		);
	}

	detalharQuestionariocandidato(idCandidato: number) {
		this.detalharRespostaCandidato$ = this.perfilProfissiograficoApi.detalharQuestionariocandidato(idCandidato).pipe(
			catchError(error => {
				this.handleError(error.error.message, '');
				throw error;
			})
		);
	}

	detalharCargo(idCargo: number) {
		this.detalharCargo$ = this.perfilProfissiograficoApi.detalharCargo(idCargo).pipe(
			catchError(error => {
				this.handleError(error.error.message, '');
				throw error;
			})
		);
	}

	obterAtividades(idCargo: number) {
		this.atividades$ = this.perfilProfissiograficoApi.obterAtividades(idCargo).pipe(
			catchError(error => {
				this.handleError(error.error?.message || 'Erro ao obter atividades do cargo', '');
				throw error;
			})
		);
	}

	downloadGraficoRadar(idCandidato: number) {
		this.perfilProfissiograficoApi.downloadGraficoRadar(idCandidato).subscribe(imageBlob => {
			const objectURL = URL.createObjectURL(imageBlob);
			this.radar = this.sanitizer.bypassSecurityTrustUrl(objectURL);
		});
	}

	downloadGraficoBarras(idCandidato: number) {
		this.perfilProfissiograficoApi.downloadGraficoBarras(idCandidato).subscribe(imageBlob => {
			const objectURL = URL.createObjectURL(imageBlob);
			this.graficoBarras = this.sanitizer.bypassSecurityTrustUrl(objectURL);
		});
	}

	downloadGraficoLinhas(idCandidato: number) {
		this.perfilProfissiograficoApi.downloadGraficoLinhas(idCandidato).subscribe(imageBlob => {
			const objectURL = URL.createObjectURL(imageBlob);
			this.graficoLinhas = this.sanitizer.bypassSecurityTrustUrl(objectURL);
		});
	}

	detalharPontuacao(idCandidato: number) {
		this.idCandidato = idCandidato;
		this.detalharPontuacaoCandidato$ = this.perfilProfissiograficoApi.detalharPontuacaoCandidato(idCandidato).pipe(
			catchError(error => {
				this.handleError(error.error?.message || 'Erro ao detalhar pontuação', '');
				throw error;
			})
		);
	}

	desconsiderarMatch(idPontuacaoIntermediaria: number): Observable<any> {
		return this.perfilProfissiograficoApi.desconsiderarMatch(idPontuacaoIntermediaria).pipe(
			catchError(error => {
				this.handleError(error.error?.message || 'Erro ao desconsiderar match', '');
				throw error;
			})
		);
	}

	private handleError(descricao: string, detalhe: string) {
		this.messageService.add({
			severity: 'error',
			summary: descricao,
			detail: detalhe
		});
	}
}
